function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.28716 17.846C7.11827 16.5101 5.10208 14.9348 3.27548 13.1491C1.98597 11.8741 1.00116 10.3173 0.396295 8.59762C-0.684456 5.2439 0.573606 1.41109 4.08605 0.273218C5.93998 -0.307392 7.95629 0.0490306 9.50668 1.23142C11.0576 0.0503529 13.0733 -0.305953 14.9273 0.273218C18.4398 1.41109 19.7063 5.2439 18.6255 8.59762C18.0256 10.3157 17.0466 11.8723 15.7632 13.1491C13.935 14.9329 11.919 16.5079 9.75154 17.846L9.51513 18L9.28716 17.846Z",
  fill: "#FFDD02"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.51036 17.9996L9.28719 17.8456C7.11562 16.5098 5.09663 14.9346 3.26707 13.1487C1.97144 11.8755 0.980765 10.3185 0.370993 8.59724C-0.701314 5.24353 0.556747 1.41071 4.06919 0.272843C5.92312 -0.307767 7.96602 0.0489285 9.51036 1.24122V17.9996Z",
  fill: "#FFDD02"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.419 6.63054C15.2281 6.61828 15.0504 6.52317 14.9275 6.36749C14.8045 6.21181 14.7471 6.00923 14.7687 5.80721C14.7893 5.14182 14.4097 4.53617 13.8242 4.30053C13.4529 4.19946 13.2281 3.79851 13.321 3.4031C13.4091 3.01405 13.7744 2.77214 14.1416 2.85971C14.188 2.86737 14.2326 2.88412 14.2732 2.90911C15.4471 3.35961 16.2072 4.57208 16.1467 5.89778C16.1448 6.09871 16.0662 6.2902 15.929 6.42835C15.7918 6.56651 15.6077 6.63948 15.419 6.63054Z",
  fill: "#2A2A2F"
});

var SvgSupportY = function SvgSupportY(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSupportY, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Support-y.bbb1918f.svg";
export { ForwardRef as ReactComponent };